<template>
  <div v-if="hasAlerts">
    <o-tooltip>
      <slot>
        <o-chip v-if="!compact" variant="danger" :size="size" icon="danger">
          {{ $t('general.alerts') }}
        </o-chip>

        <div v-if="compact" class="h-7 w-7 flex items-center justify-center rounded-lg bg-white/25">
          <o-icon class="text-red-600" :size="14" icon="danger" />
        </div>
      </slot>

      <template #content>
        <div class="flex flex-col divide-y divide-gray-700">
          <div v-for="alert in alerts" :key="alert.idNote" class="p-2">
            <p class="text-xs text-white/75">
              {{ $date.format(alert.created * 1000, $date.presets.full) }}
            </p>

            <p class="text-sm text-white">
              <span class="font-semibold">{{ getAlertTypeLabel(alert) }}</span>
              <span class="whitespace-pre-line" v-html="alert.content" />
            </p>
          </div>
        </div>
      </template>
    </o-tooltip>
  </div>
</template>

<script setup lang="ts">
interface Props {
  customer: Record<string, any>
  compact?: boolean
  size?: string
}

const props = withDefaults(defineProps<Props>(), {
  compact: false,
  size: 'sm',
})

const { $i18n } = useNuxtApp()

const alerts = computed(() => Array.isArray(props.customer?.alerts) ? props.customer.alerts : [])
const hasAlerts = computed(() => alerts.value.length > 0)

const getAlertTypeLabel = (alert: Record<string, any>) => {
  const description = alert?.type?.description

  if (typeof description !== 'string' || !description.length) {
    return ''
  }

  try {
    return $i18n.te(description) ? $i18n.t(description) : description
  } catch {
    return description
  }
}
</script>
